import { render, staticRenderFns } from "./MealIdeasView.vue?vue&type=template&id=260ead90&scoped=true"
import script from "./MealIdeasView.vue?vue&type=script&lang=js"
export * from "./MealIdeasView.vue?vue&type=script&lang=js"
import style0 from "./MealIdeasView.vue?vue&type=style&index=0&id=260ead90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ead90",
  null
  
)

export default component.exports